<template>
    <div class="menu-wrapper">
        <v-menu
            offset-y
            v-model="menu"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    :label="label"
                    autocomplete="off"
                    v-model="formattedDateText"
                    readonly
                    v-on="on"
                    append-icon="fa-calendar-day"
                />
            </template>
            <v-date-picker
                no-title
                :first-day-of-week="1"
                :locale-first-day-of-year="4"
                :value="date"
                locale="da"
                :show-week="true"
                @input = handleDateInput
            />
        </v-menu>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: [
        'date',
        'label'
        
    ],
    data () {
        return {
            menu: false
        }
    },
    computed: {
        formattedDateText () {
            return this.date ? moment(this.date).format('D. MMMM YYYY') : moment(this.today).format('D. MMMM YYYY')
        }
    },
    methods: {
        handleDateInput (date) {
            this.$emit('updateDate', date)
            this.menu = false
        }
    },
    created () {
        if (!this.date) this.date = moment().format('YYYY-MM-DD')
        this.$emit('updateDate', this.date)
    }
}
</script>